<div id="content" class="extensible">
  <div id="page-header">
    <div class="page-title">
      <h1>{{ page_title }}</h1>

      <mat-form-field appearance="outline" class="year-select small nobottom">
        <mat-label>Año</mat-label>
        <mat-select [value]="selectedYear()" (selectionChange)="selectedYear.set($event.value); onYearChange()">
          @for (y of availableYears; track y) {
            <mat-option [value]="y">{{ y }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (calculated_at()) {
        <span class="calculated-at"> Último cálculo: {{ calculated_at() | dateAgo }} </span>
      } @else if (!loading()) {
        <span class="calculated-at">—</span>
      }

      <button mat-stroked-button color="primary" [routerLink]="['..']">
        <mat-icon>arrow_back</mat-icon>
        Volver atrás
      </button>
      <button mat-stroked-button [color]="show_sensible_details() ? 'primary' : 'accent'" (click)="toggleShowSensibleDetails()">
        <mat-icon>{{ show_sensible_details() ? ' visibility_off' : 'visibility' }}</mat-icon>
        {{ show_sensible_details() ? 'Ocultar datos sensibles' : 'Mostrar datos sensibles' }}
      </button>
      <button mat-flat-button color="accent" [disabled]="loading()" (click)="onForceRecalculate()">
        <mat-icon>refresh</mat-icon>
        Forzar recálculo
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="bisual-table-container" style="max-height: calc(100vh - 208px)" #scrollContainer>
        @if (loading()) {
          <div style="display: flex; align-items: center; justify-content: center; padding: 32px 0">
            <div
              style="
                background: #ffffff;
                padding: 24px 32px;
                border-radius: 12px;
                box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 12px;
                min-width: 260px;
              "
            >
              @if (!longTaskError()) {
                <h2 style="margin: 0; font-size: 18px; font-weight: 600">Calculando planificación de producción…</h2>
                <p style="margin: 0; font-size: 13px; color: #666; text-align: center">
                  Estamos agregando horas por producto, rol y persona para el año seleccionado.
                </p>

                @if (progressPercent() !== null) {
                  <div style="position: relative; display: inline-block; margin-top: 8px">
                    <mat-progress-spinner
                      mode="determinate"
                      [value]="progressPercent()"
                      diameter="72"
                      color="accent"
                    ></mat-progress-spinner>
                    <div
                      style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-weight: 600; font-size: 16px"
                    >
                      {{ progressPercent() }}%
                    </div>
                  </div>
                } @else {
                  <mat-spinner diameter="72" color="accent"></mat-spinner>
                }

                <p style="margin: 4px 0 0; font-size: 11px; color: #999">
                  Puedes cambiar de año o forzar recálculo más tarde si lo necesitas.
                </p>
              } @else {
                <h2 style="margin: 0; font-size: 18px; font-weight: 600; color: #d32f2f">Error al calcular la planificación</h2>
                <p style="margin: 0; font-size: 13px; color: #666; text-align: center">
                  {{ longTaskError() }}
                </p>
                <p style="margin: 4px 0 0; font-size: 11px; color: #999">Intenta volver a forzar el recálculo o cambia de año.</p>
              }
            </div>
          </div>
        } @else {
          <table mat-table #table [dataSource]="dataSource" recycleRows>
            <ng-container matColumnDef="main">
              <th mat-header-cell *matHeaderCellDef style="font-weight: 700; text-transform: uppercase; z-index: 1000">Semana</th>
              <td mat-cell *matCellDef="let row; let i = index">
                <b>{{ row.user_name }} {{ row.user_surnames }}</b>
              </td>
            </ng-container>

            <!-- Primera fila de header para la columna main -->
            <ng-container matColumnDef="main-top">
              <th mat-header-cell *matHeaderCellDef style="font-weight: 700; text-transform: uppercase; z-index: 1000">Mes</th>
              <td mat-cell></td>
            </ng-container>

            @for (col_str of dynamic_columns; track col_str; let j = $index) {
              <ng-container [matColumnDef]="col_str">
                <th mat-header-cell *matHeaderCellDef class="day-column" [ngClass]="{ 'first-day-of-week': dates[j].is_first_day_of_week }">
                  <div class="day-background">
                    {{ dates[j].date | date: 'd' }}
                  </div>
                </th>
                <ng-container *matCellDef="let row; let i = index">
                  @if (dates[j].is_first_day_of_week) {
                    <td mat-cell class="day-column first-day-of-week" [attr.colspan]="dates[j].week_colspan">
                      <div class="cell-content">
                        @if (companyProductUserMemberRoles().length > 0 && row.weeks[dates[j].week_key]) {
                          @if (dates[j].week_colspan === 7) {
                            <!-- Semana completa: UI editable completa -->
                            <div class="week-edit-row">
                              <mat-form-field
                                [ngClass]="{ warn: row.weeks[dates[j].week_key].has_company_product_user_member_role_change }"
                                appearance="outline"
                                class="nobottom small role-field"
                              >
                                <mat-select
                                  panelWidth
                                  [value]="row.weeks[dates[j].week_key].company_product_user_member.company_product_user_member_role.id"
                                  [disabled]="loading() || !dates[j].is_week_editable"
                                  (selectionChange)="onMemberFieldChange(i, j, 'company_product_user_member_role_id', $event.value)"
                                >
                                  @for (pumr of companyProductUserMemberRoles(); track pumr) {
                                    <mat-option [value]="pumr.id">{{ pumr.short_name | uppercase }}</mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>

                              <div class="custom-portion-inline">
                                <mat-form-field
                                  [ngClass]="{
                                    warn:
                                      row.weeks[dates[j].week_key].has_journey_change ||
                                      row.weeks[dates[j].week_key].has_journey_inconsistency,
                                    error:
                                      jornadas_laborales[dates[j].week_key]['user_' + row.user_id] >
                                      row.weeks[dates[j].week_key].working_contract.active_working_contract_variable_condition
                                        .hours_per_week_expected -
                                        row.weeks[dates[j].week_key].working_contract.active_working_contract_variable_condition
                                          .active_department_category.active_department_category_variable_condition
                                          .max_non_productive_hours_per_week_assuming_fulltime,
                                  }"
                                  appearance="outline"
                                  class="nobottom small portion_of_productive_work_day-field"
                                >
                                  @if (portionDisplayModes()[i]?.[j] === 'input') {
                                    <input
                                      matInput
                                      type="number"
                                      min="0"
                                      max="1"
                                      step="0.01"
                                      [disabled]="loading() || !dates[j].is_week_editable"
                                      [ngModel]="$safeNavigationMigration(portionInputValues()[i]?.[j])"
                                      (ngModelChange)="onCustomPortionInputValueChange(i, j, $event)"
                                      (blur)="applyCustomPortion(i, j)"
                                      (keydown.enter)="applyCustomPortion(i, j)"
                                    />
                                  } @else {
                                    <mat-select
                                      panelWidth
                                      [attr.data-portion-key]="i + '_' + j"
                                      panelClass="portion-select-panel"
                                      [value]="$safeNavigationMigration(portionSelectValues()[i]?.[j])"
                                      [disabled]="loading() || !dates[j].is_week_editable"
                                      (selectionChange)="onMemberFieldChange(i, j, 'portion_of_productive_work_day', $event.value)"
                                    >
                                      <mat-option [value]="0"> Sin tiempo (0h) </mat-option>
                                      <mat-option [value]="0.25">
                                        1/4 jorn. ({{
                                          (row.weeks[dates[j].week_key].working_contract.active_working_contract_variable_condition
                                            .hours_per_week_expected -
                                            row.weeks[dates[j].week_key].working_contract.active_working_contract_variable_condition
                                              .active_department_category.active_department_category_variable_condition
                                              .max_non_productive_hours_per_week_assuming_fulltime) *
                                            0.25 | number: '1.0-2'
                                        }}h)
                                      </mat-option>
                                      <mat-option [value]="0.5">
                                        1/2 jorn. ({{
                                          (row.weeks[dates[j].week_key].working_contract.active_working_contract_variable_condition
                                            .hours_per_week_expected -
                                            row.weeks[dates[j].week_key].working_contract.active_working_contract_variable_condition
                                              .active_department_category.active_department_category_variable_condition
                                              .max_non_productive_hours_per_week_assuming_fulltime) *
                                            0.5 | number: '1.0-2'
                                        }}h)
                                      </mat-option>
                                      <mat-option [value]="0.75">
                                        3/4 jorn. ({{
                                          (row.weeks[dates[j].week_key].working_contract.active_working_contract_variable_condition
                                            .hours_per_week_expected -
                                            row.weeks[dates[j].week_key].working_contract.active_working_contract_variable_condition
                                              .active_department_category.active_department_category_variable_condition
                                              .max_non_productive_hours_per_week_assuming_fulltime) *
                                            0.75 | number: '1.0-2'
                                        }}h)
                                      </mat-option>
                                      <mat-option [value]="1">
                                        Jorn. Completa ({{
                                          row.weeks[dates[j].week_key].working_contract.active_working_contract_variable_condition
                                            .hours_per_week_expected -
                                            row.weeks[dates[j].week_key].working_contract.active_working_contract_variable_condition
                                              .active_department_category.active_department_category_variable_condition
                                              .max_non_productive_hours_per_week_assuming_fulltime | number: '1.0-2'
                                        }}h)
                                      </mat-option>
                                    </mat-select>
                                  }
                                </mat-form-field>
                                <button
                                  mat-icon-button
                                  class="custom-portion-icon-button"
                                  type="button"
                                  [disabled]="loading() || !dates[j].is_week_editable"
                                  matTooltip="Personalizar"
                                  (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                  (click)="
                                    $event.preventDefault();
                                    $event.stopPropagation();
                                    toggleCustomPortionMode(
                                      i,
                                      j,
                                      row.weeks[dates[j].week_key].company_product_user_member.portion_of_productive_work_day
                                    )
                                  "
                                >
                                  <mat-icon>tune</mat-icon>
                                </button>
                              </div>
                            </div>

                            <div style="display: flex; align-items: center; width: 100%; gap: 4px">
                              <span
                                [ngClass]="{ warn: row.weeks[dates[j].week_key].has_department_category_change }"
                                class="chip"
                                [matTooltip]="
                                  row.weeks[dates[j].week_key].working_contract.active_working_contract_variable_condition
                                    .active_department_category.name
                                "
                                style="flex: 1 1 auto; max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
                              >
                                {{
                                  row.weeks[dates[j].week_key].working_contract.active_working_contract_variable_condition
                                    .active_department_category.name
                                }}
                              </span>
                              <mat-form-field
                                [ngClass]="{ warn: row.weeks[dates[j].week_key].has_expected_production_prcnt_change }"
                                appearance="outline"
                                class="nobottom small expected-production-prcnt-field"
                              >
                                <input
                                  matInput
                                  type="number"
                                  min="0"
                                  max="100"
                                  step="1"
                                  [disabled]="loading() || !dates[j].is_week_editable"
                                  [ngModel]="$safeNavigationMigration(expectedProductionPrcntInputValues()[i]?.[j])"
                                  [placeholder]="'' + row.weeks[dates[j].week_key].default_expected_production_prcnt"
                                  (ngModelChange)="onExpectedProductionPrcntInputValueChange(i, j, $event)"
                                  (blur)="applyExpectedProductionPrcnt(i, j)"
                                  (keydown.enter)="applyExpectedProductionPrcnt(i, j)"
                                />
                                <span matSuffix>%</span>
                              </mat-form-field>

                              @if (dates[j].is_week_editable) {
                                <button
                                  mat-icon-button
                                  class="small-icon-button"
                                  style="flex: 0 0 auto; margin-left: auto"
                                  [disabled]="loading()"
                                  [matMenuTriggerFor]="menu"
                                >
                                  <mat-icon style="color: grey">more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                  <button mat-menu-item [disabled]="loading()" (click)="openMembersDialog(i)">
                                    <mat-icon>settings</mat-icon>
                                    <span>Configurar miembros</span>
                                  </button>
                                  <button mat-menu-item color="red" [disabled]="loading()" (click)="deleteUserFromCompanyProduct(i, j)">
                                    <mat-icon>delete</mat-icon>
                                    <span>Eliminar del producto</span>
                                  </button>
                                </mat-menu>
                              }
                            </div>
                          } @else {
                            <!-- Semana parcial: solo rol + porcentaje producción -->
                            <span class="chip">
                              {{
                                row.weeks[dates[j].week_key].company_product_user_member.company_product_user_member_role.short_name
                                  | uppercase
                              }}
                            </span>
                            <span class="chip" style="margin-left: 5px">
                              {{ row.weeks[dates[j].week_key].consolidated_expected_production_prcnt / 100 | percent: '1.0-0' }}
                            </span>
                          }
                        }
                      </div>
                    </td>
                  }
                </ng-container>
              </ng-container>

              <!-- Primera fila de header para cada día -->
              <ng-container [matColumnDef]="col_str + '-top'">
                <ng-container *matHeaderCellDef>
                  @if (dates[j].is_first_day_of_month) {
                    <th mat-header-cell class="month-cell" [attr.colspan]="dates[j].month_colspan">
                      {{ dates[j].date | date: 'MMMM yyyy' | titlecase }}
                    </th>
                  }
                </ng-container>
                <td mat-cell *matCellDef="let row; let i = index">
                  <!-- Contenido de la celda para la primera fila -->
                </td>
              </ng-container>
            }

            <tr mat-header-row *matHeaderRowDef="columns_top"></tr>
            <tr mat-header-row *matHeaderRowDef="columns"></tr>
            <ng-container *matRowDef="let row; columns: columns">
              @if (row.is_first_row_of_contract) {
                <tr class="contract-header">
                  <td class="mat-column-main">
                    <div class="contract-header-cell-content">
                      <div class="contract-header-left">
                        <b class="contract-header-title">{{ row.company_product_title }}</b>
                        <span
                          class="contract-header-hours"
                          [matTooltip]="
                            $safeNavigationMigration(contract_year_summary[row.contract_id]?.previstas_netas) === null ||
                            $safeNavigationMigration(contract_year_summary[row.contract_id]?.planificadas) === null
                              ? ''
                              : contract_year_summary_tooltips[row.contract_id]
                          "
                        >
                          @if (
                            $safeNavigationMigration(contract_year_summary[row.contract_id]?.previstas_netas) === null ||
                            $safeNavigationMigration(contract_year_summary[row.contract_id]?.planificadas) === null
                          ) {
                            ??h / ??h
                          } @else {
                            @if (hoursDisplayMonthly()) {
                              {{ (contract_year_summary[row.contract_id]?.previstas_netas ?? 0) / 12 | number: '1.1-1' }}h /
                              {{ (contract_year_summary[row.contract_id]?.planificadas ?? 0) / 12 | number: '1.1-1' }}h
                            } @else {
                              {{ contract_year_summary[row.contract_id]?.previstas_netas ?? 0 | number: '1.0-0' }}h /
                              {{ contract_year_summary[row.contract_id]?.planificadas ?? 0 | number: '1.0-0' }}h
                            }
                          }
                        </span>
                      </div>
                      @if (
                        $safeNavigationMigration(contract_year_summary[row.contract_id]?.previstas_netas) !== null &&
                        $safeNavigationMigration(contract_year_summary[row.contract_id]?.planificadas) !== null
                      ) {
                        <button
                          mat-icon-button
                          type="button"
                          class="small-icon-button hours-toggle-icon-button contract-header-toggle"
                          (click)="toggleHoursDisplayMonthly(); $event.stopPropagation()"
                          [matTooltip]="hoursDisplayMonthly() ? 'Ver en formato anual' : 'Ver en formato mensual'"
                        >
                          <mat-icon>sync_alt</mat-icon>
                        </button>
                      }
                    </div>
                  </td>
                  @for (date of dates; track date.date) {
                    @if (date.is_first_day_of_month) {
                      <td class="day-cell month-cell" [attr.colspan]="date.month_colspan">
                        <span>Estimación: </span>
                        <b
                          >{{
                            company_products_monthly['company_product_' + row.company_product_id]?.months?.[getMonthKey(date.date)]
                              ?.expected_hours_budgetable ?? 0 | number: '1.0-2'
                          }}h</b
                        >
                        @if (show_sensible_details()) {
                          -
                          {{
                            company_products_monthly['company_product_' + row.company_product_id]?.months?.[getMonthKey(date.date)]
                              ?.expected_billing ?? 0 | currency
                          }}
                        }
                        @if (date.is_past_month) {
                          <div class="month-actual-hours">
                            Registradas:
                            {{
                              company_products_monthly['company_product_' + row.company_product_id]?.months?.[getMonthKey(date.date)]
                                ?.done_hours_for_client ?? 0 | number: '1.0-2'
                            }}h
                          </div>
                        }

                        @let economic_entry = economic_reports_by_key()['company_product_' + row.company_product_id + '_' + date.month_key];
                        @if (economic_entry) {
                          @if (date.is_past_month && economic_entry.report.ro_total_hours_billed !== null) {
                            <div class="month-billed-hours">
                              Facturadas: {{ economic_entry.report.ro_total_hours_billed | number: '1.0-2' }}h
                            </div>
                          }

                          <div class="month-economic-actions">
                            @if (economic_entry.payment_status_info !== null) {
                              <mat-icon
                                class="month-payment-icon"
                                [class]="economic_entry.payment_status_info.class"
                                [matTooltip]="economic_entry.payment_status_info.tooltip"
                              >
                                {{ economic_entry.payment_status_info.icon }}
                              </mat-icon>
                            }
                            <button
                              mat-icon-button
                              type="button"
                              class="small-icon-button"
                              (click)="openEconomicReportDetail(economic_entry.report.id); $event.stopPropagation()"
                              matTooltip="Ver informe económico"
                            >
                              <mat-icon>info</mat-icon>
                            </button>
                          </div>
                        }
                      </td>
                    }
                  }
                </tr>
              }
              <tr mat-row></tr>
              @if (row.is_last_row_of_contract) {
                <tr class="week-recap">
                  <td class="mat-column-main"></td>
                  @for (date of dates; track date.date; let j = $index) {
                    @if (date.is_first_day_of_week) {
                      <td class="day-cell first-day-of-week mat-mdc-cell" [attr.colspan]="date.week_colspan">
                        @if (week_role_display[dates[j].week_key] && week_role_display[dates[j].week_key]['contract_' + row.contract_id]) {
                          <div class="cell-content">
                            @for (item of week_role_display[dates[j].week_key]['contract_' + row.contract_id]; track item.roleKey) {
                              @if (date.week_colspan === 7) {
                                <li style="display: flex; align-items: center; width: 100%; margin: 5px 0">
                                  <span
                                    class="chip"
                                    [ngClass]="{
                                      'chip-red-border': item.color === 'red',
                                    }"
                                    style="
                                      margin-right: 5px;
                                      margin-top: unset;
                                      min-width: 30px;
                                      text-align: center;
                                      justify-content: center;
                                    "
                                    >{{ item.shortName }}</span
                                  >
                                  <mat-progress-bar
                                    style="flex-grow: 1"
                                    mode="determinate"
                                    [color]="item.color"
                                    [value]="item.percentage"
                                  ></mat-progress-bar>
                                  <span style="font-size: 12px; min-width: 70px; margin-left: 5px; text-align: right">
                                    {{ item.currPrcnt / 100 | percent: '1.0-0' }} /
                                    {{ item.optimalPrcnt / 100 | percent: '1.0-0' }}
                                  </span>
                                </li>
                              } @else {
                                <li style="display: flex; align-items: center; width: 100%; margin: 5px 0">
                                  <span
                                    class="chip"
                                    [ngClass]="{
                                      'chip-red-border': item.color === 'red',
                                    }"
                                    style="
                                      margin-right: 8px;
                                      margin-top: unset;
                                      min-width: 30px;
                                      text-align: center;
                                      justify-content: center;
                                    "
                                    >{{ item.shortName }}</span
                                  >
                                  <span style="font-size: 12px; text-align: left">
                                    {{ item.currPrcnt / 100 | percent: '1.0-0' }} /
                                    {{ item.optimalPrcnt / 100 | percent: '1.0-0' }}
                                  </span>
                                </li>
                              }
                            }
                          </div>
                        }
                      </td>
                    }
                  }
                </tr>
              }
            </ng-container>
          </table>
        }
      </div>
    </div>
  </div>
</div>
